
import DataTable from 'primevue/datatable'

export default {
  components: {DataTable},
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    scrollHeight: {type: String, default: undefined}
  },
  data() {
    return {scrolled: false}
  },
  mounted() {
    this.updateScroll()
  },
  updated() {
    this.updateScroll()
  },
  methods: {
    updateScroll() {
      const container = this.$el.querySelector('.table-container')
      this.scrolled = !!container && container.scrollHeight > container.clientHeight && container.scrollTop > 0
    }
  }
}
